import { ZodSchema, ZodError } from 'zod';
import { Rule } from 'antd/es/form';

export function zodToAntdRules<T>(schema: ZodSchema<T>): Rule[] {
  const rules: Rule[] = [];

  // Add native required visual cue if schema is not optional
  if (!schema.isOptional && typeof schema.isOptional === 'function' && !schema.isOptional()) {
    rules.push({
      required: true,
      message: 'Campo obbligatorio',
    });
  }

  rules.push({
    async validator(_, value) {
      try {
        schema.parse(value);
        return Promise.resolve();
      } catch (err) {
        if (err instanceof ZodError) {
          // Return first error message from Zod
          return Promise.reject(err.errors[0].message);
        }
        return Promise.reject('Errore di validazione');
      }
    },
  });

  return rules;
}
